var map = {
	"./": [
		"./src/customers/imsgiotto/index.js",
		[
			"src_customers_imsgiotto_index_js"
		]
	],
	"./index": [
		"./src/customers/imsgiotto/index.js",
		[
			"src_customers_imsgiotto_index_js"
		]
	],
	"./index.js": [
		"./src/customers/imsgiotto/index.js",
		[
			"src_customers_imsgiotto_index_js"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 7 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/customers/imsgiotto lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;